<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M4.4,783.54l1.29,1.29l-5.19,5.19l-5.19-5.19l1.28-1.29l3.9,3.91L4.4,783.54L4.4,783.54z M4.4,789.91l1.29,1.28l-5.19,5.19
	l-5.19-5.19l1.28-1.28l3.9,3.9L4.4,789.91L4.4,789.91z M8.68,798.73l1.82,2.73h-20l1.82-2.73H8.68L8.68,798.73z"/>
</svg>

</template>